import React from 'react';
import sprintf from 'sprintf';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import 'react-mdl/extra/material.js';
import {Textfield, Checkbox} from 'react-mdl';

class SMLoginView extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      resource: this.props.resource,
      resource_name: this.props.resource_name,
      authenticity_token: this.props.authenticity_token,
      errors: [],
    };
    
    this.hundleSubmit = this.hundleSubmit.bind(this);
    this.facebookLoginHandler = this.facebookLoginHandler.bind(this);
  }

  componentDidMount() {
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }

  setFacebookLoginFlag() {
    sessionStorage.facebookLoginFlag = 1;
  }

  facebookLoginHandler() {
    this.setFacebookLoginFlag();
    this.trackPageEvent('account sign_in facebook');
  }

  hundleSubmit(e) {
    let errors = {};
    
    if(this.refs.mail.inputRef.value.trim() == "") {
      errors['email'] = sprintf(I18n.t("service.error_000002"), I18n.t("service.label_000500"));
    }

    if(this.refs.password.inputRef.value.trim() == "") {
      errors['password'] = sprintf(I18n.t("service.error_000002"), I18n.t("service.label_000501"));
    }
    
    if(Object.keys(errors).length > 0) {
      e.preventDefault();
      this.setState({errors: errors});
    }
  }

  loginFormSignUpClick() {
    SMTrackHelper.pageEvent('account toggle to_sign_up');
    SMTrackHelper.criteoBasket("", "createUser", 2000, 1);
  }

  renderErrorForm(type) {
    if(this.state.errors[type]) {
      let message = this.state.errors[type];
      return (
        <p className="signup-box__required"><i className="fa fa-exclamation-circle" />{message}</p>
      );
    }
  }
  
  render() {

    return (
      <div className="site-main">
        <div className="page__even lp-page__padding">
          <div className="page__col1">
            <div className="signup-head">
              <h1 className="page-title">{I18n.t("service.label_000026")}</h1>
            </div>
            <div className="signup-box signup-box__line">
              <div className="row col-signup__pd">
                <div className="col-sm-12 col-md-6">
                  <h2 className="signup-box__title">{I18n.t("service.text_000008")}</h2>
                  <ul className="signup-box__sns">
                    <li><a href={Routes.user_omniauth_authorize_path('facebook')} className="button-facebook pt15 pb15 w100pa" onClick={this.facebookLoginHandler}>
                      <span className="signup-box__sns-button">{I18n.t("service.text_000009")}</span></a></li>
                  </ul>
                  <p className="signup-box__notes">{I18n.t("service.text_000010")}<br className="sm-hide" />{I18n.t("service.text_000011")}
                  </p>
                </div>
                
                <div className="col-sm-12 col-md-6 sm-signup-box__line">
                  <form ref="form" action={Routes.user_session_path()} method="post" onSubmit={this.hundleSubmit.bind(this)} acceptCharset="UTF-8">
                    <h2 className="signup-box__title">{I18n.t("service.text_000012")}</h2>
                    <div className="signup-box__md-top">
                      <input name="utf8" type="hidden" value="✓" />
                      <input type="hidden" name='authenticity_token' value={this.state.authenticity_token} />
                      <input type="hidden" name='done' value={this.props.params.done} />
                      <Textfield
                        ref="mail"
                        className="w100pa"
                        id="mail"
                        name="user[email]"
                        label={I18n.t("service.label_000500")}
                        floatingLabel
                        />
                      {this.renderErrorForm('email')}
                      <Textfield
                        ref="password"
                        type="password"
                        className="w100pa"
                        id="password"
                        name="user[password]"
                        label={I18n.t("service.label_000501")}
                        floatingLabel
                      />
                      {this.renderErrorForm('password')}
                    </div>
                    <div className="signup-box__login-checkbox">
                      <Checkbox
                        id="checkbox-1"
                        className="mdl-checkbox__input"
                        name="user[remember_me]"
                        label={I18n.t("service.text_000007")}
                        />
                    </div>
                    <p className="signup-box__login-btn">
                      <input type="submit" name="commit" className="button-blue pt15 pb15 w100pa" value={I18n.t("service.label_000026")} />
                    </p>
                  </form>
                  <div className="ta-c">
                    <p><a href={Routes.new_user_password_path()} className="a__underline">{I18n.t("service.text_000013")}</a></p>
                  </div>
                </div>
              </div>
            </div>

            <div className="signup-box">
              <div className="row">
                <div className="col-xs-12 ta-c">
                  <h2 className="signup-box__title signup-box__title-other">{I18n.t("service.text_000014")}<br className="pc-hide__sm-show" />{I18n.t("service.label_000100")}</h2>
                  <a href={Routes.new_user_registration_path()} className="button-blue pt15 pb15 w200 sm-w100" onClick={this.loginFormSignUpClick.bind(this)}>{I18n.t("service.label_000027")}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SMLoginView;



// WEBPACK FOOTER //
// ./app/javascript/components/sessions/SMLoginView.jsx